import React from 'react';

import {useNavigate} from 'react-router-dom';

const useCustomNavigate = () => {
  const navigate = useNavigate();

  const customNavigate = React.useCallback((to, options) => {
    navigate(to, options);
  }, [navigate]);

  return customNavigate;
};

export default useCustomNavigate;
